'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UNAUTHORIZED = exports.UNAUTHORIZED = 'AUTHENTICATION:UNAUTHORIZED';

var LOCAL_BASE_URL = exports.LOCAL_BASE_URL = 'https://development.doctify.co.uk';

var GOOGLE_MAP_KEY = exports.GOOGLE_MAP_KEY = 'AIzaSyDo4wXu_w6ZGSb18EBkRvYvNh-zmrTnDB0';

var DROPDOWN_TOP_SPECIALTIES_WEIGHTS = exports.DROPDOWN_TOP_SPECIALTIES_WEIGHTS = {
  'dermatology': 1,
  'obstetrics & gynaecology': 2,
  'dentistry': 3,
  'orthopaedic surgery': 4,
  'paediatrics': 5,
  'ear nose & throat surgery': 6
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-utils/lib/constants.js
// module id = 172
// module chunks = 0